import { useMutation } from "@tanstack/react-query";
import { actions } from "astro:actions";
import { navigate } from "astro:transitions/client";
import { $path } from "astro-typesafe-routes/path";
import { toast } from "sonner";

import { DialogBody } from "~/components/DialogBody";
import { DialogFooter } from "~/components/DialogFooter";
import { DialogHeader } from "~/components/DialogHeader";
import { PackForm } from "~/components/PackForm";
import { QuotaAlert } from "~/components/QuotaAlert";
import { useQuota } from "~/hooks/quota";
import { trackEvent } from "~/utils/analytics";
import { slugify } from "~/utils/slug";

export const CreatePack: React.FC = () => {
  const quota = useQuota();

  const { mutate, isPending, isSuccess, error } = useMutation({
    mutationFn: actions.pack.create.orThrow,
    onSuccess: (data) => {
      trackEvent("pack_created");
      navigate(
        $path({
          to: "/account/packs/[slug]",
          params: {
            slug: slugify(data),
          },
        }),
      );
    },
    onError: (error) => {
      toast.error("Failed to create pack", {
        description: error.message,
      });
    },
  });

  return (
    <form
      className="contents"
      onSubmit={async (event) => {
        event.preventDefault();
        const formData = new FormData(event.currentTarget);
        mutate(formData);
      }}
    >
      <DialogHeader>Create a pack</DialogHeader>
      <DialogBody>
        <PackForm error={error}>
          <QuotaAlert quota={quota.packs} type="pack" />
        </PackForm>
      </DialogBody>
      <DialogFooter>
        <button
          disabled={!quota.packs || isPending || isSuccess}
          className="btn btn-secondary btn-block"
          type="submit"
        >
          Create pack
        </button>
      </DialogFooter>
    </form>
  );
};
